import type { ComponentProps } from "react"

import { P3 } from "../Typographies"

type Props = React.PropsWithChildren<{ disabled?: boolean } & ComponentProps<typeof P3>>

export default function FieldLabelSmall({ children, disabled, ...otherProps }: Props) {
  return (
    <P3 color={disabled ? "textSubtle" : "textMuted"} {...otherProps}>
      {children}
    </P3>
  )
}
